import { Box, Button, HStack, Image, Text } from "@chakra-ui/react";

import { useParams } from "react-router-dom";

import useNamedNavigate from "@/hooks/navigation/useNamedNavigate";

interface IntegrationCardProps {
  platform: {
    name: string;
    category: string;
    displayName: string;
    description: string;
    imageLink: string;
    isDisabled?: boolean;
  };
}

export const IntegrationCard: React.FC<IntegrationCardProps> = ({
  platform
}) => {
  const { clientId, companyId } = useParams();
  const navigate = useNamedNavigate();

  const handleClick = () => {
    if (clientId) {
      navigate("settings.client.connections.detail", {
        clientId,
        category: platform.category,
        platform: platform.name
      });
    } else if (companyId) {
      navigate("settings.company.connections.detail", {
        companyId,
        category: platform.category,
        platform: platform.name
      });
    }
  };

  return (
    <Box
      opacity={platform.isDisabled ? 0.4 : 1}
      pointerEvents={platform.isDisabled ? "none" : "initial"}
      bg={platform.isDisabled ? "gray.50" : "white"}
      px={6}
      py={6}
      h={320}
      pos="relative"
      border="1px solid"
      rounded={6}
      borderColor="blackAlpha.200"
    >
      <HStack spacing={4}>
        <Text fontSize={20} fontWeight={600}>
          {platform.displayName}
        </Text>
      </HStack>

      <Text mt={3} fontSize={12} mb={8} fontWeight={400}>
        {platform.description}
      </Text>

      <Image
        alt={platform.name}
        src={platform.imageLink}
        width={50}
        height={50}
      />

      <HStack pos="absolute" bottom={6} justify="space-between">
        <Button
          h={9}
          onClick={handleClick}
          variant={platform.isDisabled ? "outline" : "solid"}
          colorScheme="primary"
          minW={130}
          size="sm"
          isDisabled={platform.isDisabled}
        >
          {platform.isDisabled ? "Coming soon..." : "Manage"}
        </Button>
      </HStack>
    </Box>
  );
};
